import React from 'react';

import Preloader from '@components/Common/Preloader';
import { PageLayout } from '@components/Layout';
import TelegramSubscription from '@components/TelegramSubscription/TelegramSubscription';
import { useTelegramSubscription } from '@components/TelegramSubscription/useTelegramSubscription';
import { VerificationProvider, VerificationsSuccess } from '@components/Verification';
import { useVerificationRequestQuery } from '@hooks/queries/useVerificationRequestQuery';
import { useText } from '@hooks/useText';
import { VERIFICATION_STATUS } from '@interfaces/user';

const VerificationPage = () => {
  const { data: verification, isLoading } = useVerificationRequestQuery();
  const { t } = useText();
  const { isSubscribed, handleSubscribe } = useTelegramSubscription();

  if (isLoading) {
    return <Preloader />;
  }

  if (!verification) {
    return null;
  }

  const isVerificationInProgress =
    verification.status === VERIFICATION_STATUS.PENDING ||
    verification.status === VERIFICATION_STATUS.PENDING_FUTURES ||
    verification.status === VERIFICATION_STATUS.REJECTED;

  const showTelegramSubscription =
    verification.status !== VERIFICATION_STATUS.VERIFIED &&
    !isVerificationInProgress &&
    !isSubscribed;

  const showVerificationProvider =
    verification.status !== VERIFICATION_STATUS.VERIFIED &&
    (isVerificationInProgress || isSubscribed);

  return (
    <PageLayout title={t('verification.title')} contentClassName="justify-center">
      {verification.status === VERIFICATION_STATUS.VERIFIED && <VerificationsSuccess />}
      {showTelegramSubscription && (
        <TelegramSubscription onSubscribeHandler={handleSubscribe} />
      )}
      {showVerificationProvider && (
        <VerificationProvider
          provider={verification.provider}
          data={verification.data}
          status={verification.status}
        />
      )}
    </PageLayout>
  );
};

export default React.memo(VerificationPage);
